"use strict";
var forms_1 = require('@angular/forms');
var lang_1 = require('../facade/lang');
exports.date = function (control) {
    if (lang_1.isPresent(forms_1.Validators.required(control)))
        return null;
    var v = control.value;
    return lang_1.isDate(v) ? null : { date: true };
};
//# sourceMappingURL=validator.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-validation/dist/date/validator.js
// module id = 1145
// module chunks = 10